import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    addendumsCard: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    }
  })
